import { ofetch } from 'ofetch'
import { defineComponent } from '~/scripts/utils/alpine'

interface BlogPostsOptions {
  url: string
}

export default defineComponent((options: BlogPostsOptions) => ({
  selectedCategory: '',
  loading: false,
  error: false,
  init() {
    this.$nextTick(() => {
      this.$watch('selectedCategory', (value) => this.onSelectCategory(value))
    })
  },
  onSelectCategory(value: string) {
    // Update page URL
    const url = new URL(globalThis.location.href)
    url.searchParams.set('cat', value)
    history.pushState({}, '', url.toString())

    // Create fetch URL
    const fetchUrl = new URL(options.url)
    fetchUrl.searchParams.set('cat', value)
    this.fetchPosts(fetchUrl.toString(), true)
  },
  loadMore(event: Event) {
    if (event.currentTarget instanceof HTMLAnchorElement) {
      const link = event.currentTarget
      event.preventDefault()
      this.fetchPosts(link.href)
    }
  },
  async fetchPosts(url: string, replace?: boolean) {
    try {
      this.loading = true
      this.error = false
      const response = await ofetch<{ data: string }>(url)

      // Replace the content of the grid with the new content
      if (replace) {
        this.$refs.grid.innerHTML = response.data
      }
      // Replace the load more element with the new content
      else {
        const loadMore = this.$root.querySelector<HTMLDivElement>('.load-more')
        loadMore!.outerHTML = response.data
      }
    } catch {
      this.error = true
    } finally {
      this.loading = false
    }
  },
}))
